import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var BracketsRight = props => {
  var {
    BracketsRight: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BracketsRight');
  return null;
};
BracketsRight.displayName = 'JVR.BracketsRight';